module.exports = __webpack_public_path__ + "img/footer-wx.8945b7d4.png";